import {
  CREATE_OR_UPDATE_CATEGORY,
  CREATE_OR_UPDATE_CATEGORY_ERROR,
  CREATE_OR_UPDATE_CATEGORY_SUCCESS,
  GET_CATEGORY,
  GET_CATEGORY_ERROR,
  GET_CATEGORY_SUCCESS,
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_ERROR,
  GET_CATEGORY_LIST_SUCCESS
} from "../actions/categoryAction";

const initialState = {
  categories: [], //THIS IS UESED FOR TO HOLD ARRAY DATA
  categoryList: [], //THIS IS UESED FOR TO HOLD ARRAY DATA
  data: {}, // THIS IS USED FOR TO HOLD SAVE DATA
  loading: false,
  loaded: false,
  saving: false,
  saved: false,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_CATEGORY:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case GET_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        categories: action.payload.success,
      };

    case GET_CATEGORY_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
        categories: [],
      };

    case CREATE_OR_UPDATE_CATEGORY:
      return {
        ...state,
        saving: true,
        saved: false,
        error: null,
      };

    case CREATE_OR_UPDATE_CATEGORY_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
        data: action.payload.success,
      };

    case CREATE_OR_UPDATE_CATEGORY_ERROR:
      return {
        ...state,
        saving: false,
        saved: false,
        error: action.payload.error,
        data: {},
      };

      case GET_CATEGORY_LIST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case GET_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        categoryList: action.payload.success,
      };

    case GET_CATEGORY_LIST_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
        categoryList: [],
      };

    default:
      return state;
  }
}
